// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2WkOl","head":"Table_head__2aXNN","col":"Table_col__2XOMR"};